import { AccessTime } from "@mui/icons-material";
import { useField, useFormikContext } from "formik";
import { StyledFormikTimePicker } from "../../styled/FormikTimePicker";

const FormikTimePicker = (props) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  const handleChange = (value) => {
    setFieldValue(props.name, value);
  };

  return (
    <StyledFormikTimePicker.Picker
      ampm={false}
      autoOk={true}
      keyboardIcon={<AccessTime />}
      {...props}
      {...field}
      error={meta.touched && meta.error ? true : false}
      helperText={meta.touched && meta.error ? meta.error : null}
      onChange={handleChange}
      slotProps={{
        textField: {
          variant: "standard",
          fullWidth: props.fullWidth || false,
          size: props.size || "medium",
          helperText: meta.touched && meta.error ? meta.error : null,
          error: meta.touched && meta.error ? true : false,
        }
      }}
    />
  );
};

export default FormikTimePicker;
